import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { format } from 'date-fns';
import { ConfigBaseFilter, ListLayout, SimpleConfigBaseFilter } from 'gung-list';
import { CustomerService, MetadataService, Order, OrderListConfigService } from 'gung-standard';
import { JeevesOrderCardListComponent } from '../../components/jeeves-order-card-list/jeeves-order-card-list.component';

export class OrderDateFilter extends SimpleConfigBaseFilter<Order> {
  type = 'dateRangeFilter';

  getName(): string {
    return 'ORDER_DATE';
  }

  getOptionIds(item: Order): string[] {
    if (item?.extra?.oh?.orddatum) {
      return [format(new Date(item.extra.oh.orddatum), 'yyMMdd')];
    }
    return [];
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class OrderExpectedDeliveryFilter extends SimpleConfigBaseFilter<Order> {
  type = 'dateRangeFilter';

  getName(): string {
    return 'EXPECTED_DELIVERY_DATE';
  }

  getOptionIds(item: Order): string[] {
    return [format(new Date(item.extra.oh.ordberlevdat), 'yyMMdd')];
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class OrderStatusFilter extends SimpleConfigBaseFilter<Order> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'ORDER_STATUS';
  }
  getOptionIds(item: Order): string[] {
    const value = this.metadataService.getMetadataValue('x7', 'ordstatbeskr', item.extra.oh.ordstat);
    return [value];
  }
  getOptionName(key: string): string {
    return key;
  }
}

export class OrderTypeFilter extends SimpleConfigBaseFilter<Order> {
  constructor(protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'ORDER_TYPE';
  }
  getOptionIds(item: Order): string[] {
    const value = this.metadataService.getMetadataValue('x6', 'ordtypbeskr', item.extra.oh.ordtyp);
    return [value];
  }
  getOptionName(key: string): string {
    return key;
  }
}

@Injectable({
  providedIn: 'root'
})
export class JeevesOrderListConfigService extends OrderListConfigService {
  protected translationService = inject(TranslateService);
  protected metadataService = inject(MetadataService);
  protected customerService = inject(CustomerService);

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        ...super.getLayouts()[0],
        getListItemComponent: () => JeevesOrderCardListComponent
      }
    ];
  }

  getFilters(): ConfigBaseFilter<Order>[] {
    return [
      new OrderDateFilter(),
      new OrderExpectedDeliveryFilter(),
      new OrderStatusFilter(this.metadataService),
      new OrderTypeFilter(this.metadataService)
    ];
  }

  getSearchTerms(item: Order): string[] {
    return [item.id, item.extra.oh.kundref2, item.extra.oh.kundbestnr];
  }
}
